/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_EmailInputs */

const en_form_email = /** @type {(inputs: Form_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const he_form_email = /** @type {(inputs: Form_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אימייל`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Form_EmailInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const form_email = /** @type {((inputs?: Form_EmailInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_EmailInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_email(inputs)
	return he_form_email(inputs)
});